export default {
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    ok() {
      this.$emit('ok')
    },
  },
}
